/** Visual ranks only: never alters the measured score. */
export const PERFORMANCE_BADGE_NAMES = [
  'Running on empty',
  'A little spark',
  'Gaining energy',
  'Building momentum',
  'Picking up speed',
  'Ready to accelerate',
  'Powered up',
  'High performance',
  'Powerhouse',
  'Extraordinary',
  'Limit breaker',
] as const;
export function performanceBadgeRank(score: number | null): number | null {
  if (score === null || !Number.isFinite(score) || score < 1 || score > 100) return null;
  return Math.floor(Math.round(score) / 10);
}
